import { Button } from "primereact/button";

export default function LogoutButton() {
  const logMeOut = () => {
    localStorage.removeItem('portal_rs_auth');
    window.location.reload();
  };

  return (
    <Button
      icon="pi pi-sign-out"
      rounded
      text
      severity="secondary"
      onClick={logMeOut}
      tooltip="Logout"
      tooltipOptions={{ position: 'bottom' }}
    />
  );
}
